import logo from "@/assets/images/logo.png";
import { cn } from "@/lib/helper/utils";
import { FC } from "react";

type AuthLogoProps = {
  wrapperClasses?: string;
};

const AuthLogo: FC<AuthLogoProps> = ({ wrapperClasses }) => {
  return (
    <div
      className={cn(
        "flex flex-col rtl justify-center items-center",
        wrapperClasses
      )}
    >
      <img src={logo} alt="log" className="w-[84px] mb-5 aspect-[84/100]" />
      <h1 className="font-extrabold text-gray-500">Nakhll VPOS</h1>
      <p className="text-lg font-bold">
        کارتـخوان مجـازی بـازار اجتـماعی نــخل
      </p>
      <h2 className="text-primary text-sm font-medium">نسخه مستقل VPOS ویژه صاحبان و نمایندگان مجاز کسب و کارها</h2>
    </div>
  );
};

export default AuthLogo;
